import { MapProperties } from '@datum-group/datum-map/lib';
import { services } from '../../../../../API';
import {
  MouseController,
  EventsCardMouseControllerLink,
} from '../../../../../store/MouseController';
import { EventsLayer } from '../../../../../store/EventsOpen/EventsLayer';
import { SingleWindow } from '../../../../../store/Window';
import { IEventsItemProperties } from '../../../../../store/EventsOpen/types';

export class MapWidgetEventsStore {
  readonly layerLoader: EventsLayer;
  readonly cardToMouseLink: EventsCardMouseControllerLink;
  readonly card: SingleWindow<IEventsItemProperties>;

  constructor(mapProperties: MapProperties, mouseController: MouseController) {
    this.layerLoader = new EventsLayer(
      services.eventsGeoJSONLayer.get,
      mapProperties.map,
      {
        mode: 'viewing',
      },
    );

    this.card = new SingleWindow<IEventsItemProperties>();
    this.cardToMouseLink = new EventsCardMouseControllerLink(
      mouseController,
      this.card,
    );
  }
}
